/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_FactsInputs */

const en_directory_knowledge_facts = /** @type {(inputs: Directory_Knowledge_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified facts`)
};

const zh_directory_knowledge_facts = /** @type {(inputs: Directory_Knowledge_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证事实`)
};

/**
* | output |
* | --- |
* | "Verified facts" |
*
* @param {Directory_Knowledge_FactsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_facts = /** @type {((inputs?: Directory_Knowledge_FactsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_FactsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_facts(inputs)
	return zh_directory_knowledge_facts(inputs)
});
export { directory_knowledge_facts as "directory.knowledge.facts" }